import {reqDetails,reqDetailsimg} from '@/api';
// 用来存储数据
const state = {
    details:{
        p:{
            name:''
        },
        child:{
            id:'',
            name:'',
        },
        data:[{
            
        }]

    },
    img:'/img/default.1f00bdad.jpg',


}
// 响应组件中的事件
const actions = {
    async getDetails({commit},params){
        let result = await reqDetails(params);
        if(result.code == 200){
            commit('details',result.data);
        }
    },
    async getDetailsimg({commit},params){
        let result = await reqDetailsimg(params);
        if(result.code == 200){
            commit('img',result.data[0].img);
        }
    },
    
}
// 操作数据
const mutations = {
    details(state,details){
        let tbdata = Object.getOwnPropertyNames(details.data[0]);
        tbdata.pop();
        const tabledata = [];
        const ar = ['制造商零件编号','图像','制造商','Digi-Key 零件编号','现有数量','单价USD','最低订购数量是','规格书']
        for(const a of ar){
            tbdata.splice(tbdata.indexOf(a), 1)
        }
        for(const s of tbdata){
            tabledata.push({'name':s,'data':details.data[0][s]})
        }
        details['tbdata'] = tabledata;
        state.details = details;
        

    },
    img(state,img){
        if(img != 'http://media.digikey.com/Photos/NoPhoto/NoPhoto_TMB.jpg'){
            state.img = img;
        }
        
    },
    
}
// 用来将state数据进行加工
const getters = {

}

export default {
    state,
    actions,
    mutations,
    getters
}